import { PageRefLink } from "./PageRefLink";
import type { BoqKeyItem } from "./types";

export const KeyItemsTable = ({
  items,
  onNavigate,
}: {
  items: BoqKeyItem[];
  onNavigate: (file: string, page: number) => void;
}) => {
  return (
    <table className="w-full text-xs">
      <thead>
        <tr className="text-left text-gray-500 border-b border-gray-100">
          <th className="py-1 pr-2 font-medium">Pos.</th>
          <th className="py-1 pr-2 font-medium">Description</th>
          <th className="py-1 pr-2 font-medium text-right">Qty</th>
          <th className="py-1 pr-2 font-medium">Unit</th>
          <th className="py-1 font-medium">Page</th>
        </tr>
      </thead>
      <tbody>
        {items.map((ki, i) => (
          <tr key={i} className="border-b border-gray-50">
            <td className="py-1 pr-2 font-mono text-gray-600">
              {ki.position_number}
            </td>
            <td className="py-1 pr-2 text-gray-800">{ki.description}</td>
            <td className="py-1 pr-2 text-right text-gray-700">
              {ki.quantity}
            </td>
            <td className="py-1 pr-2 text-gray-500">{ki.unit}</td>
            <td className="py-1">
              {ki.page && ki.file && (
                <PageRefLink
                  file={ki.file}
                  page={ki.page}
                  onNavigate={onNavigate}
                />
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
